const $ = require('jquery');

$(document).ready(function() {
  // object to track if an event has already been sent
  var eventSentMap = {
    'automated seo': false,
    'design elements': false,
    'responsive themes': false,
    support: false,
    'einfaches setup': false,
    'geringe kosten': false,
    video: false,
    starter: false,
    professional: false,
    enterprise: false,
    educational: false,
    'start shop': false,
  };

  // Send ga event if the different sections have been viewed
  $('#video, #industries, #features, #prices').each(function() {
    var sectionVisitedDebounce = _.debounce(sectionVisited, 3000);

    $(this).on('inview', function(event, isInView) {
      if (isInView && event.target.id !== '') {
        sectionVisitedDebounce({ eventLabel: event.target.id });
      } else {
        sectionVisitedDebounce.cancel();
      }
    });
  });

  function sectionVisited(cfg) {
    if (!window.gtag) {
      return;
    }

    // Unsubscribe from 'inview' to send the ga event only once for each section
    $('section[id="' + cfg.eventLabel + '"]').off('inview');

    gtag('event', 'main_page_section_view', {
      event_label: cfg.eventLabel,
    });
  }

  // Send ga event if the different tabs have been clicked
  $('[data-tab]').on('click', function() {
    if (!window.gtag) {
      return;
    }

    var eventLabel = $(this)
      .find('span')
      .text();
    eventLabel = eventLabel.toLowerCase();

    switch (eventLabel.toLowerCase()) {
      case 'geringe kosten':
        eventLabel = 'low cost';
        break;
      case 'einfaches setup':
        eventLabel = 'simple setup';
        break;
      default:
        eventLabel = eventLabel;
        break;
    }

    if (eventSentMap[eventLabel]) {
      return;
    }

    gtag('event', 'main_page_tab_view', {
      event_label: 'feature ' + eventLabel,
    });

    eventSentMap[eventLabel] = true;
  });

  // Send ga event if the video button has been clicked
  $('.oc-section_intro-video button').on('click', function() {
    if (!window.gtag) {
      return;
    }

    if (eventSentMap['video']) {
      return;
    }

    gtag('event', 'main_page_show_video', {
      event_label: 'introduction',
    });

    eventSentMap.video = true;
  });

  // Send ga event if any of the packages has been selected
  $('.start-shop').each(function() {
    $(this).on('click', function() {
      if (!window.gtag) {
        return;
      }

      var label = $(this).attr('href');
      label = label.match(/\=(.*)$/i);

      if (eventSentMap[label[1]]) {
        return;
      }

      gtag('event', 'main_page_start_shop', {
        event_label: label[1],
      });

      eventSentMap[label[1]] = true;
    });
  });

  $('.request-educational').on('click', function() {
    if (!window.gtag) {
      return;
    }

    if (eventSentMap['educational']) {
      return;
    }

    gtag('event', 'main_page_start_shop', {
      event_label: 'educational',
    });

    eventSentMap.educational = true;
  });

  $('.oc-button--intro').on('click', function() {
    if (!window.gtag) {
      return;
    }

    if (eventSentMap['start shop']) {
      return;
    }

    gtag('event', 'main_page_start_shop_button_clicked', {});

    eventSentMap['start shop'] = true;
  });
});
